document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const panel = document.querySelector('[data-mobile-panel]');

  if (toggle && panel) {
    toggle.addEventListener('click', () => {
      const isOpen = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('no-scroll', isOpen);
    });

    panel.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        panel.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('no-scroll');
      });
    });
  }

  const marketplaceSearch = document.querySelector('[data-agent-search]');
  const cards = Array.from(document.querySelectorAll('[data-agent-card]'));
  const filterButtons = Array.from(document.querySelectorAll('[data-agent-filter]'));
  const emptyState = document.querySelector('[data-agent-empty]');
  let activeDepartment = 'all';

  const filterAgents = () => {
    const query = marketplaceSearch ? marketplaceSearch.value.trim().toLowerCase() : '';
    let visibleCount = 0;

    cards.forEach((card) => {
      const text = card.textContent.toLowerCase();
      const department = card.dataset.department || '';
      const departmentMatch = activeDepartment === 'all' || department === activeDepartment;
      const searchMatch = !query || text.includes(query);
      const isVisible = departmentMatch && searchMatch;
      card.style.display = isVisible ? '' : 'none';
      if (isVisible) visibleCount += 1;
    });

    if (emptyState) emptyState.hidden = visibleCount !== 0;
  };

  if (cards.length) {
    if (marketplaceSearch) marketplaceSearch.addEventListener('input', filterAgents);
    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeDepartment = button.dataset.agentFilter || 'all';
        filterButtons.forEach((btn) => btn.classList.toggle('is-active', btn === button));
        filterAgents();
      });
    });
  }

  const orgList = document.querySelector('[data-org-list]');
  const orgScore = document.querySelector('[data-org-score]');
  const orgPayroll = document.querySelector('[data-org-payroll]');
  const orgCount = document.querySelector('[data-org-count]');
  const modal = document.querySelector('[data-agent-modal]');
  const modalBody = document.querySelector('[data-modal-body]');
  const modalAdd = document.querySelector('[data-modal-add]');
  const selectedAgents = new Map();
  const departments = Array.from(document.querySelectorAll('[data-coverage]')).map((node) => node.dataset.coverage).filter(Boolean);
  const storageKey = 'eclawmerce-ai-org-v1';
  let activeModalAgent = null;

  const getDeploymentPath = (selected) => {
    const count = selected.length;
    const coveredDepartments = new Set(selected.map((agent) => agent.department)).size;
    if (!count) return 'No employees yet';
    if (count <= 2) return 'Micro-SaaS pilot';
    if (count <= 5 || coveredDepartments <= 2) return 'Starter AI workspace';
    if (count <= 10) return 'Department rollout';
    return 'Custom AI operating system';
  };

  const escapeHtml = (value) => String(value || '').replace(/[&<>"]/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
  }[char]));

  const splitList = (value) => String(value || '').split(';').map((item) => item.trim()).filter(Boolean);

  const agentFromCard = (card) => {
    if (!card) return null;
    return {
      slug: card.dataset.agentSlug,
      name: card.dataset.agentName,
      department: card.dataset.department,
      icon: card.dataset.agentIcon || '✓',
      initials: card.dataset.agentInitials || 'AI',
      role: card.dataset.agentRole,
      avatarUrl: card.querySelector('.ec-agent-avatar img')?.getAttribute('src'),
      tagline: card.dataset.agentTagline,
      planLabel: card.dataset.agentSalaryLabel,
      planScore: Number(card.dataset.agentSalary || 0),
      description: card.dataset.agentDescription,
      bestFor: card.dataset.agentBestFor,
      outputs: card.dataset.agentOutputs,
      worksWith: card.dataset.agentWorksWith,
      skills: card.dataset.agentSkills,
      tools: card.dataset.agentTools,
      modes: card.dataset.agentModes,
      resume: card.dataset.agentResume,
    };
  };

  const getAgentBySlug = (slug) => agentFromCard(document.querySelector(`[data-agent-card][data-agent-slug="${slug}"]`));

  const saveOrganization = () => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(Array.from(selectedAgents.values())));
    } catch (error) {
      // Ignore storage failures in private browsing or locked-down browsers.
    }
  };

  const updateAddButtons = () => {
    document.querySelectorAll('[data-add-agent]').forEach((button) => {
      const slug = button.dataset.agentSlug;
      const isSelected = selectedAgents.has(slug);
      button.textContent = isSelected ? '✓ Added' : '+ Add';
      button.classList.toggle('is-added', isSelected);
    });

    if (modalAdd && activeModalAgent) {
      const isSelected = selectedAgents.has(activeModalAgent.slug);
      modalAdd.textContent = isSelected ? '✓ Added to my org' : '+ Add to my org';
      modalAdd.classList.toggle('is-added', isSelected);
    }
  };

  const renderOrgChart = (selected) => {
    departments.forEach((department) => {
      const node = document.querySelector(`[data-org-chart-department="${department}"]`);
      if (!node) return;
      const agents = selected.filter((agent) => agent.department === department);
      const small = node.querySelector('small');
      node.classList.toggle('is-covered', agents.length > 0);
      if (!small) return;
      if (!agents.length) {
        small.textContent = 'Missing';
        return;
      }
      const names = agents.slice(0, 3).map((agent) => `${agent.icon} ${agent.name}`).join(' · ');
      small.textContent = agents.length > 3 ? `${names} +${agents.length - 3} more` : names;
    });
  };

  const getSelectedOrg = () => Array.from(selectedAgents.values());

  const summarizeAiOrg = (selected = getSelectedOrg()) => {
    const deploymentPath = getDeploymentPath(selected);
    const groups = selected.reduce((acc, agent) => {
      const department = agent.department || 'Unassigned';
      if (!acc[department]) acc[department] = [];
      acc[department].push(agent);
      return acc;
    }, {});
    const departmentLines = Object.keys(groups).sort().map((department) => {
      const names = groups[department].map((agent) => `${agent.name} (${agent.planLabel || 'Flexible plan'})`).join(', ');
      return `- ${department}: ${names}`;
    });

    return {
      deploymentPath,
      selected,
      text: [
        'Selected AI organization from the Hire AI Employees marketplace:',
        ...departmentLines,
        `Recommended deployment path: ${deploymentPath}`,
        'I want help validating, sequencing, and deploying this AI team affordably.',
      ].join('\n'),
    };
  };

  const prefillAiOrgForms = () => {
    const selected = getSelectedOrg();
    const summaryNodes = document.querySelectorAll('[data-ai-org-summary]');
    const hiddenOrgFields = document.querySelectorAll('[data-ai-org-field]');
    const hiddenPayrollFields = document.querySelectorAll('[data-ai-payroll-field], [data-ai-plan-field]');
    const messageFields = document.querySelectorAll('[data-ai-org-message]');

    if (!selected.length) return;

    const summary = summarizeAiOrg(selected);
    const encoded = summary.selected.map((agent) => `${agent.department}: ${agent.name} (${agent.planLabel || 'Flexible plan'})`).join('; ');

    hiddenOrgFields.forEach((field) => { field.value = encoded; });
    hiddenPayrollFields.forEach((field) => { field.value = summary.deploymentPath; });
    messageFields.forEach((field) => {
      if (!field.value.trim()) field.value = summary.text;
    });
    summaryNodes.forEach((node) => {
      node.hidden = false;
      node.innerHTML = `<strong>AI org selections loaded</strong><p>${escapeHtml(encoded)}</p><small>Recommended deployment path: ${escapeHtml(summary.deploymentPath)}</small>`;
    });
  };

  const updateAiOrgLinks = () => {
    const selected = getSelectedOrg();
    if (!selected.length) return;
    const slugs = selected.map((agent) => agent.slug).filter(Boolean).join(',');
    document.querySelectorAll('[data-ai-org-link]').forEach((link) => {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      url.searchParams.set('ai_org', '1');
      if (slugs) url.searchParams.set('agents', slugs);
      link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    });
  };

  const renderOrganization = () => {
    if (!orgList) return;
    const selected = Array.from(selectedAgents.values());
    const deploymentPath = getDeploymentPath(selected);
    const covered = new Set(selected.map((agent) => agent.department));
    const score = departments.length ? Math.round((covered.size / departments.length) * 100) : 0;

    if (orgScore) orgScore.textContent = String(score);
    if (orgPayroll) orgPayroll.textContent = deploymentPath;
    if (orgCount) orgCount.textContent = `${selected.length} employee${selected.length === 1 ? '' : 's'} selected`;

    departments.forEach((department) => {
      const node = document.querySelector(`[data-coverage="${department}"]`);
      if (node) {
        const count = selected.filter((agent) => agent.department === department).length;
        node.textContent = count ? `${count} hired` : 'Missing';
        node.classList.toggle('is-covered', count > 0);
      }
    });

    if (!selected.length) {
      orgList.innerHTML = '<p>No team members selected yet.</p>';
      renderOrgChart(selected);
      updateAddButtons();
      return;
    }

    orgList.innerHTML = departments.map((department) => {
      const agents = selected.filter((agent) => agent.department === department);
      if (!agents.length) return '';
      return `<div class="ec-org-selected-group"><strong>${escapeHtml(department)}</strong>${agents.map((agent) => `<span>${escapeHtml(agent.icon)} ${escapeHtml(agent.name)} <button type="button" data-remove-agent="${escapeHtml(agent.slug)}" aria-label="Remove ${escapeHtml(agent.name)}">Remove</button></span>`).join('')}</div>`;
    }).join('');

    renderOrgChart(selected);
    updateAddButtons();
    updateAiOrgLinks();
  };

  const addAgent = (agent) => {
    if (!agent || !agent.slug) return;
    selectedAgents.set(agent.slug, agent);
    saveOrganization();
    renderOrganization();
  };

  const toggleAgent = (agent) => {
    if (!agent || !agent.slug) return;
    if (selectedAgents.has(agent.slug)) selectedAgents.delete(agent.slug);
    else selectedAgents.set(agent.slug, agent);
    saveOrganization();
    renderOrganization();
  };

  const renderModalBody = (agent, mode) => {
    const outputs = splitList(agent.outputs);
    const worksWith = splitList(agent.worksWith);
    const skills = String(agent.skills || '').split(',').map((item) => item.trim()).filter(Boolean);

    if (mode === 'interview') {
      return `
        <div class="ec-agent-interview">
          <p><strong>Interview goal:</strong> Decide whether ${escapeHtml(agent.name)} belongs in your first AI hiring round.</p>
          <div class="ec-interview-prompts">
            <div><span>1</span><p>What monthly output should this employee own?</p></div>
            <div><span>2</span><p>Which tools or workflows should they connect to?</p></div>
            <div><span>3</span><p>Which department should they report into?</p></div>
          </div>
          <div class="ec-help-box">
            <strong>Recommended pairing</strong>
            <p>${escapeHtml(agent.worksWith)}</p>
          </div>
          <div class="ec-help-box">
            <strong>Deployment note</strong>
            <p>${escapeHtml(agent.name)} can start as a tasked employee, then move into OpenClaw, Hermes, or a bespoke workflow once the operating rhythm is proven.</p>
          </div>
        </div>`;
    }

    return `
      <div class="ec-agent-resume">
        <p>${escapeHtml(agent.resume)}</p>
        <div class="ec-agent-modal-grid">
          <div><strong>Best for</strong><span>${escapeHtml(agent.bestFor)}</span></div>
          <div><strong>Tools</strong><span>${escapeHtml(agent.tools)}</span></div>
          <div><strong>Works with</strong><span>${escapeHtml(agent.worksWith)}</span></div>
          <div><strong>Deployment modes</strong><span>${escapeHtml(agent.modes)}</span></div>
        </div>
        <div class="ec-help-box">
          <strong>Monthly outputs</strong>
          <ul>${outputs.map((item) => `<li>${escapeHtml(item)}</li>`).join('')}</ul>
        </div>
        <div class="ec-help-box">
          <strong>Core skills</strong>
          <div class="ec-help-tags">${skills.map((skill) => `<span>${escapeHtml(skill)}</span>`).join('')}</div>
        </div>
      </div>`;
  };

  const openAgentModal = (agent, mode = 'resume') => {
    if (!modal || !agent) return;
    activeModalAgent = agent;
    const title = document.querySelector('[data-modal-title]');
    const role = document.querySelector('[data-modal-role]');
    const department = document.querySelector('[data-modal-department]');
    const avatar = document.querySelector('[data-modal-avatar]');
    const salary = document.querySelector('[data-modal-salary]');
    const tagline = document.querySelector('[data-modal-tagline]');
    const contact = document.querySelector('[data-modal-contact]');

    if (title) title.textContent = mode === 'interview' ? `Interview ${agent.name}` : `${agent.name} Resume`;
    if (role) role.textContent = agent.role || '';
    if (department) department.textContent = agent.department || '';
    if (avatar) {
      avatar.innerHTML = agent.avatarUrl
        ? `<img src="${escapeHtml(agent.avatarUrl)}" alt="${escapeHtml(agent.name)} AI employee avatar">`
        : `<b>${escapeHtml(agent.initials)}</b><small>${escapeHtml(agent.icon)}</small>`;
    }
    if (salary) salary.textContent = agent.planLabel || 'Flexible plan';
    if (tagline) tagline.textContent = agent.tagline || '';
    if (contact) contact.href = `/pages/contact?agent=${encodeURIComponent(agent.slug)}`;
    if (modalBody) modalBody.innerHTML = renderModalBody(agent, mode);

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    updateAddButtons();
  };

  const closeAgentModal = () => {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  };

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest('[data-add-agent]');
    if (addButton) {
      const agent = getAgentBySlug(addButton.dataset.agentSlug) || {
        slug: addButton.dataset.agentSlug,
        name: addButton.dataset.agent,
        department: addButton.dataset.department,
        icon: addButton.dataset.icon || '✓',
        planScore: Number(addButton.dataset.salary || 0),
      };
      toggleAgent(agent);
      return;
    }

    const removeButton = event.target.closest('[data-remove-agent]');
    if (removeButton) {
      selectedAgents.delete(removeButton.dataset.removeAgent);
      saveOrganization();
      renderOrganization();
      return;
    }

    const modalTrigger = event.target.closest('[data-open-agent-modal]');
    if (modalTrigger) {
      openAgentModal(getAgentBySlug(modalTrigger.dataset.agentSlug), modalTrigger.dataset.modalMode || 'resume');
      return;
    }

    if (event.target.closest('[data-modal-close]')) {
      closeAgentModal();
    }
  });

  if (modalAdd) {
    modalAdd.addEventListener('click', () => {
      if (activeModalAgent) addAgent(activeModalAgent);
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAgentModal();
  });

  try {
    const saved = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
    if (Array.isArray(saved)) {
      saved.forEach((agent) => {
        const fresh = getAgentBySlug(agent.slug);
        selectedAgents.set(agent.slug, fresh || agent);
      });
    }
  } catch (error) {
    // Ignore corrupt or unavailable localStorage.
  }

  prefillAiOrgForms();
  renderOrganization();
  updateAiOrgLinks();
});
